import {
  BasicButton,
  ButtonGroup,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  PrimaryButton,
  SelectItem,
  Select,
  Text,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";

import { LANGUAGE_OPTIONS } from "./constants";
import { useLanguage } from "./hooks/useLanguage";

export function LanguageModal() {
  const { t, i18n } = useTranslation();

  const [selectedLanguage, setSelectedLanguage] = useState<string>(
    i18n.language
  );

  const { changeLanguage } = useLanguage();

  return (
    <Modal>
      <Dialog>
        {({ close }) => (
          <>
            <DialogHeader testID="language">
              {t("Language and region")}
            </DialogHeader>
            <DialogContent>
              <Text style="form/body-secondary" color="text-weak">
                <Trans>
                  This will change the language settings within your profile.
                </Trans>
              </Text>
              <div
                className={css({
                  marginTop: "var(--space-2)",
                })}
              >
                <Select
                  selectedKey={selectedLanguage}
                  name="language"
                  aria-label={t("Language")}
                  onSelectionChange={(key) =>
                    setSelectedLanguage(key?.toString() ?? "")
                  }
                  testID="language-select"
                  items={LANGUAGE_OPTIONS}
                >
                  {(item) => (
                    <SelectItem id={item.value} textValue={item.display_value}>
                      {item.display_value}
                    </SelectItem>
                  )}
                </Select>
              </div>
            </DialogContent>
            <DialogFooter>
              <ButtonGroup>
                <BasicButton size="medium" onPress={close}>
                  <Trans>Cancel</Trans>
                </BasicButton>
                <PrimaryButton
                  onPress={async () => {
                    await changeLanguage(selectedLanguage);
                    close();
                  }}
                  size="medium"
                  testID="save-language-button"
                >
                  <Trans>Save</Trans>
                </PrimaryButton>
              </ButtonGroup>
            </DialogFooter>
          </>
        )}
      </Dialog>
    </Modal>
  );
}
